// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2ufzf","dragIcon":"Choice_dragIcon__C25Yd","left":"Choice_left__3EZ1U","input":"Choice_input__fJiki"};